//时间戳转换方法    date:时间戳数字
import {langPackage} from "@/common/lang";

export const time2Date = function (time, format = 'Y-m-d H:i:s') {
    if (!time) return ''
    const date = new Date(time * 1000)
    const YY = date.getFullYear()
    const MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
    const DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
    const hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
    const mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    const ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())

    format = format.replace('Y', YY).replace('m', MM)
        .replace('d', DD)
        .replace('H', hh)
        .replace('i', mm)
        .replace('s', ss)
    return format
}

// 2002-04-14 格式转换成时间戳
export const date2Time = function (s) {
    return new Date(s.replace(/-/g, '/')).getTime() / 1000
}

import Cookie from 'js-cookie'

export const cks = Cookie.withConverter({
    read: function (val, name) {
        return decodeURIComponent(val)
    },
    write: function (val, name) {
        return encodeURIComponent(val)
    }
})

// 判端域名，返回recaptcha使用域名
export const getRecaptchaHost = function () {
    const hostname = window.location.hostname
    const domain = hostname.substring(hostname.indexOf('.') + 1).toLowerCase()
    let recaptchaHost = 'www.google.com'
    if (domain === 'heycharge.global' || domain === 'wocharge.com') {
        recaptchaHost = 'www.recaptcha.net'
    }
    return recaptchaHost
}

// 获取浏览器的默认语言
export const getDefaultLanguage = function () {
    const defaultLan = 'en'
    const userLanguage = window.navigator.language ? window.navigator.language : defaultLan
    const lanCode = userLanguage.substring(0, 2).toLowerCase()
    let exists = false
    for (let key in langPackage) {
        if (key === lanCode) {
            exists = true
            break
        }
    }
    return exists ? lanCode : defaultLan
}

export const formattedAccount = function (amount, currency = 'USD', locale) {
    const normalizeAmount = (value) => {
        if (value && typeof value === 'object' && 'amount' in value) {
            return Number(value.amount) || 0
        }
        return Number(value) || 0
    }

    const c = (currency || 'USD').toString().toUpperCase()
    const localeMap = {
        USD: 'en-US',
        CNY: 'zh-CN',
        EUR: 'de-DE'
    }
    const useLocale = locale || localeMap[c] || 'en-US'
    const value = normalizeAmount(amount)

    try {
        return value.toLocaleString(useLocale, { style: 'currency', currency: c })
    } catch (e) {
        try {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
        } catch (err) {
            return String(value)
        }
    }
}
